import jQuery from 'jquery';

// Element.prototype.closest
import 'element-closest';

// Polyfill global CustomEvent
import 'custom-event-polyfill';

// Polyfill global requestAnimationFrame
import 'request-animation-frame-polyfill';

// Import javascript library via AMD loader
import SmoothScroll from '../etc/designs/portal/clientlibs/shared/js/vendor/smooth-scroll';

jQuery(function() {

	// Only init if data-flag is set on body tag
	if (jQuery('BODY').data('is-smooth-anchor-enabled')) {
		/* tslint:disable-next-line:no-unused-expression */
		new SmoothScroll('a[href*="#"]', {
			crisisHeader: '.crisis',
			emitEvents: false,
			header: '.scsh-dynamic, .modSharedHeader',
		});
	}

});



// WEBPACK FOOTER //
// typescript://../clientlibs/js/bootstrap/smooth-scroll.ts